import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {selectError} from '../../selectors/commonSelector';
import {RootMachineContext} from '../../machines/rootMachine/rootMachine.context';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {ErrorMessage} from '@spaced-out/ui-design-system/lib/components/ErrorMessage';


export const ErrorPage = () => {
  const {t} = useLabelTranslation();
  const rootMachine = RootMachineContext.useActorRef();

  const {errorMessage, allowRetry} = RootMachineContext.useSelector((state) =>
    selectError(state, t),
  );

  const onRetry = () => {
    rootMachine.send({type: 'retry'});
  };

  return (
    <ErrorMessage
      imageVariant="serverError"
      // already translated in errorMessage
      // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
      title={errorMessage}
      {...(allowRetry && {
        description: t(
          'We_couldn\'t_load_the_meeting_details_Please_try_again',
          'We couldn\'t load the meeting details. Please try again',
        ),
      })}
    >
      {allowRetry && <Button onClick={onRetry}>{t('Retry', 'Retry')}</Button>}
    </ErrorMessage>
  );
};
